import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { ErrorModal } from "../../../common/errorModal";
import { ConfirmationModal } from "../../../common/ConfirmationModal";

import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import moment from "moment";
import { formatDate, formatDateTime } from "../../../../common/Validations";
import ItemService from "../../../../services/commonService";
import { toastFunc } from "../../../../components/common/util";

const MaterialTraceReports = ({ embedded = false }) => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [jobcardList, setJobcardList] = useState([]);
  const [materialTraceNo, setMaterialTraceNo] = useState("");
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [reloadFlag, setReloadFlag] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [clear, setClear] = useState(false);

  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: t("msg_master_list.msg_materialTrace.materialTraceNumber"),
      selector: (row) => row.materialTraceNumber,
      sortable: true,
      width: "220px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.materialTraceNumber} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
      selector: (row) => row.requiredDate,
      sortable: true,
      width: "110px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_customer"),
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.customerName}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_plan"),
      selector: (row) => row.plan,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{moment(row.plan).format("MMM-YYYY")}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_planType"),
      selector: (row) => row.planType,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.planType}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard_status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          {row.jobcardStatus === "Inprogress" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Open" ? (
            <span className="bg-table-status bg-table-new-status">
              {/* {row.jobcardStatus} */}
              NOT Acknowledged
            </span>
          ) : row.jobcardStatus === "Stopped" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Closed" ? (
            <span className="bg-table-status bg-table-info-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Complete" ? (
            <span className="bg-table-status bg-table-documentNumber-status">
              {row.jobcardStatus}
            </span>
          ) : (
            <>{row.jobcardStatus}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toMachine"),
      selector: (row) => row.toMachineCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.toMachineCode ? (
            <span className="bg-table-status bg-table-second-status">
              {row.toMachineCode} - {row.toMachineName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_teamlead"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.loginUserId}- {row.loginUserName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_action"),
      selector: (row) => row.createdDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.createdDate)}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_operator"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.operatorUserId}- {row.operatorUserName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_action"),
      selector: (row) => row.operatorcreatedDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {formatDateTime(row.operatorcreatedDate)}
          </p>
        </div>
      ),
    },
  ];


  const handleUpdate = async (value) => {
    let param = {};
    param.url = "updateMaterialTraceNumber";
    param.page = Constants.REPORTS.MATERIALTRACEREPORT.update;
    param.materialTraceNumber = materialTraceNo.trim();
    param.jobcardList = jobcardList;
    await ItemService.updateMaterialTrace(param).then((item) => {
      if (item?.status === 200) {
        setConfirmModel(false);
        toastFunc(
          Constants.MASTER.TOAST.success,
          "Wire Trace Number updated successfully",
          2000
        );
        setClear(true);
        setReloadFlag(true);
        setJobcardList([]);
        setSelectedRows([]);
        setMaterialTraceNo("");
      } else {
        setError(item?.message || "Unable to update the Wire Trace Number.");
        setIsError(true);
      }
    });
  }

  const updateMaterialTrace = async (value) => {
    if (!materialTraceNo.trim()) {
      setError("Wire Trace Number is required.");
      setIsError(true);
      return;
    }

    const materialTraceFound = selectedRows.some((row) =>
      String(row.materialTraceNumber || "").trim()
    );

    if (materialTraceFound) {
      setConfirmModel(true);
    } else if (selectedRows.length > 0) {
      await handleUpdate()
    } else {
      setError(t("msg_common.no_rows"));
      setIsError(true);
    }
  }

  const handleSelectedRowsChange = ({ selectedRows }) => {
    const selectedJobcardList = selectedRows.map((item) => item.jobcard);
    setSelectedRows([...selectedRows]);
    setJobcardList([...selectedJobcardList]);
    setReloadFlag(false);
    setClear(false);
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const PageContainer = embedded ? "section" : "main";

  return (
    <PageContainer
      className={embedded ? "generatejobcard" : "generatejobcard main"}
      id={embedded ? undefined : "main"}
    >
      <Row className="justify-center subContent wire-trace-header">
        <Col xs={12} md={5} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_master_list.msg_materialTrace.msg_materialTrace_title")}
            </h2>
            <p className="subText">
              {t("msg_master_list.msg_materialTrace.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={12} md={7} className="wire-trace-header__actions">
          <Form.Group
            className="wire-trace-header__update"
            controlId="wireTraceNumber"
          >
            <Form.Label>
              <i className="bi bi-upc-scan" aria-hidden="true" />
              {t("msg_common.materialtracenumber")}
            </Form.Label>
            <Form.Control
              type="text"
              value={materialTraceNo || ""}
              placeholder="Enter wire trace number"
              onChange={(e) => setMaterialTraceNo(e.target.value)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
              required
            />
            <Button variant="primary" onClick={updateMaterialTrace}>
              Update
            </Button>
          </Form.Group>
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary searchFilter-btn wire-trace-header__filter"
            aria-label="Filter wire trace records"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i className="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>
      <div>
        <ReportList
          selectableRows
          reloadFlag={reloadFlag}
          columnsData={columnsData}
          displayMaterialTraceFilter={displayFilter}
          handleSelections={handleSelectedRowsChange}
          //rowsData={rowsData}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_master_list.msg_materialTrace.msg_materialTrace_title"
          )}
          clearSelectedRows={clear}
          pageURL={Constants.REPORTS.MATERIALTRACEREPORT.list}
          name={Constants.REPORTS.MATERIALTRACEREPORT.name}
        />
      </div>
      {isError && (
        <ErrorModal
          show={isError}
          heading={t(
            "msg_master_list.msg_materialTrace.msg_materialTrace_title"
          )}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_materialTrace.update_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_materialTrace.msg_material_trace_exists")}
          onOk={() => handleUpdate()}
          onHide={() => setConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
    </PageContainer>
  );
};

export default MaterialTraceReports;
